import { render } from "./BlockFigure.vue?vue&type=template&id=f14f8bd6&ts=true"
import script from "./BlockFigure.vue?vue&type=script&lang=ts"
export * from "./BlockFigure.vue?vue&type=script&lang=ts"

import exportComponent from "/home/marvin/go/src/github.com/emvi/lernapp-prototype/app/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__